import { render, staticRenderFns } from "./VisitPrimaryViewPanel.vue?vue&type=template&id=18ebbccb&scoped=true"
import script from "./VisitPrimaryViewPanel.vue?vue&type=script&lang=js"
export * from "./VisitPrimaryViewPanel.vue?vue&type=script&lang=js"
import style0 from "./VisitPrimaryViewPanel.vue?vue&type=style&index=0&id=18ebbccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebbccb",
  null
  
)

export default component.exports